import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaPlus, FaSignOutAlt, FaArrowLeft } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isOnAddToiletPage = location.pathname === '/add-toilet';
  

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand-link">
          <h1 className="navbar-brand">
            LOOWAY
          </h1>
        </Link>
        <div className="navbar-actions">
          {user ? (
            <>
              {/* Show Add Toilet button on desktop for all pages except AddToilet page */}
              {!isOnAddToiletPage && window.innerWidth > 768 && (
                <Link 
                  to="/add-toilet" 
                  className="nav-action-link"
                >
                  <FaPlus size={20} />
                  Add Toilet
                </Link>
              )}
              
              {/* Show Back to Search button on desktop for AddToilet page */}
              {isOnAddToiletPage && window.innerWidth > 768 && (
                <Link 
                  to="/" 
                  className="nav-action-link"
                >
                  <FaArrowLeft size={20} />
                  Back to Search
                </Link>
              )}
              
              {/* Show Logout button only on desktop */}
              {window.innerWidth > 768 && (
                <button 
                  onClick={logout} 
                  className="logout-button"
                >
                  <FaSignOutAlt size={20} />
                  Logout
                </button>
              )}
            </>
          ) : null}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 